// FETCH PICKUP TIME
export const FETCH_PICKUP_TIME = "FETCH_PICKUP_TIME";
export const FETCH_PICKUP_TIME_SUCCESS = "FETCH_PICKUP_TIME_SUCCESS";
export const FETCH_PICKUP_TIME_ERROR = "FETCH_PICKUP_TIME_ERROR";

export const UPDATE_PICKUP_TIME = "UPDATE_PICKUP_TIME";
export const UPDATE_PICKUP_TIME_SUCCESS = "UPDATE_PICKUP_TIME_SUCCESS";
export const UPDATE_PICKUP_TIME_ERROR = "UPDATE_PICKUP_TIME_ERROR";

export const FETCH_RESTAURANTS_STATUSSES = "FETCH_RESTAURANTS_STATUSSES";
export const FETCH_RESTAURANTS_STATUSSES_SUCCESS =
  "FETCH_RESTAURANTS_STATUSSES_SUCCESS";
export const FETCH_RESTAURANTS_STATUSSES_ERROR =
  "FETCH_RESTAURANTS_STATUSSES_ERROR";

export const UPDATE_RESTAURANT_STATUS = "UPDATE_RESTAURANT_STATUSS";
export const UPDATE_RESTAURANT_STATUS_SUCCESS =
  "UPDATE_RESTAURANT_STATUSS_SUCCESS";
export const UPDATE_RESTAURANT_STATUS_ERROR = "UPDATE_RESTAURANT_STATUSS_ERROR";

// POS SETTINS

export const EDIT_RESTAURANT_SEND_TO_POS_SAGA =
  "EDIT_RESTAURANT_SEND_TO_POS_SAGA";

export const GET_RESTAUANT_SEND_TO_POS_SAGA = "GET_RESTAUANT_SEND_TO_POS_SAGA";
export const GET_RESTAUANT_SEND_TO_POS_SUCCESS =
  "GET_RESTAUANT_SEND_TO_POS_SUCCESS";

// BUSY MODE

export const FETCH_BUSY_MODES = "FETCH_BUSY_MODES";
export const FETCH_BUSY_MODES_SUCCESS = "FETCH_BUSY_MODES_SUCCESS";
export const SET_BUSY_MODE = "SET_BUSY_MODE";
export const DELETE_BUSY_MODE = "DELETE_BUSY_MODE";
export const SET_BUSY_MODE_ERROR = "SET_BUSY_MODE_ERROR";

export const EDIT_RETRY_COUNT = "EDIT_RETRY_COUNT";
export const FETCH_RETRY_COUNT = "FETCH_RETRY_COUNT";
export const FETCH_RETRY_COUNT_SUCCESS = "FETCH_RETRY_COUNT_SUCCESS";

export const SET_STORE_AUTO_OPEN = "SET_STORE_AUTO_OPEN";